import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { PerfilDocumentoModalConfig } from './perfil-documento-modal.model';
import { AnalyticsTagService } from 'src/app/services/analytics-tag.service';

@Component({
  selector: 'app-perfil-documento-modal',
  templateUrl: './perfil-documento-modal.component.html',
  styleUrls: ['./perfil-documento-modal.component.scss'],
  standalone: false,
})
export class PerfilDocumentoModalComponent {
  @Input()
  @HostBinding('class.perfil-documento-modal-host--open')
  open = false;

  /** Contenido del modal (tips + imagen ejemplo opcional). */
  @Input() config: PerfilDocumentoModalConfig | null = null;

  @Output() closed = new EventEmitter<void>();
  @Output() subir = new EventEmitter<void>();

  get isSingleLayout(): boolean {
    return this.config?.sampleLayout === 'single';
  }

  get hasSamples(): boolean {
    return (this.config?.samples?.length ?? 0) > 0;
  }

  constructor(private readonly analyticsTag: AnalyticsTagService) {}

  onClose(): void {
    this.closed.emit();
  }

  onSubir(): void {
    this.analyticsTag.trackCtaClick({
      ctaLabel: this.config?.cta ?? 'Subir',
      ctaSection: 'perfil-documento-modal',
      ctaComponent: 'perfil-documento-modal',
      ctaElementId: 'btn-perfil-documento-modal-subir',
      hu: '8099',
    });
    this.subir.emit();
  }

  onBackdrop(event: MouseEvent): void {
    if (event.target === event.currentTarget) {
      this.onClose();
    }
  }
}
